import * as React from "react";
const SvgIcView = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.5 4.167v11.666h15.833V4.167H2.5Zm1.667 1.666h12.5v3.334h-12.5V5.833Zm0 8.334v-3.334H7.5v3.334H4.167Zm5 0v-3.334h7.5v3.334h-7.5Z" /></svg>;
export default SvgIcView;